import { LineInterfaceState, initialLineState } from '../state/line.state';
import { LineActions, ELineActions } from '../actions/line.actions';

export function lineReducer(state: LineInterfaceState = initialLineState, action: LineActions): LineInterfaceState {
  switch (action.type) {
    case ELineActions.GetLineSuccess: {
      return { ...state, line: action.payload };
    }

    case ELineActions.SetSelectedLine: {
      return { ...state, line: action.payload };
    }

    default:
      return state;
  }
};
